import React, { useContext, useState, useEffect } from 'react';
import './BatteryLife.scss';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import IconElectricity from '../../../assets/Icons/icon_electricity.svg';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
faBatteryHalf,
faBatteryFull,
faBatteryQuarter,
faBatteryThreeQuarters,
faBatteryEmpty,
faInfoCircle
} from '@fortawesome/free-solid-svg-icons';
import { Paper, Button, Grid } from '@material-ui/core';
import { BusContext } from '../../Contexts/BusContext';
import api from '../../../utils/api';
import { CircularProgress } from '@material-ui/core';


export const BatteryLife = () =>{

   // Battery life data available for below serviceModelName only
   const SMN_EV_101B = 'BES CM2450 EV101B';

   const {equipmentStatus} = useContext(BusContext);
   const esnAndEquipIdList = [];
   const [batteryPackSummaryList, setBatteryPackSummaryList] = useState([]);
   const [batteryLifeInfoList, setBatteryLifeInfoList] = useState([]);
   const [loading, setLoading] = useState(false);

   //console.log(' *** equipmentStatus: '+equipmentStatus);

   if (equipmentStatus) {
    Object.keys(equipmentStatus).forEach(key => {
      const obj = equipmentStatus[key];
      esnAndEquipIdList.push({
        ssn:obj.esn.S,
        customerEquipId:obj.customerEquipId.S
      });
    });
   }

  //console.log('esnAndEquipIdList: '+esnAndEquipIdList);

  useEffect(() => {
    //console.log('useEffect log ');
    if (equipmentStatus) {
      api.getEvBatteryLifeStatus
      .post({
        ssnInfoList : esnAndEquipIdList
      })
      .then((res) => {
        //console.log('useEffect api res: '+res);
        setBatteryPackSummaryList(res.batteryPackSummaryList);
        setBatteryLifeInfoList(res.batteryLifeInfoList);
        setLoading(true);
      })
      .catch((err) => {
        console.log('error in getEvBatteryLifeStatus api: '+err);
        setLoading(false);
      });
    };
}, [equipmentStatus])


  return loading ? (
    <>

    <Paper className="btr-disclaimer">
      <div>
         <p className='btr-disclaimer-heading'><b>Disclaimer</b></p>
        <em>
          <ul>
            <li>The estimated battery life data presented is exclusively related to SMN - BES CM2450 EV101B. This data does not apply to other models or variants.</li>
            <li>This estimated data is intended for informational purposes only and should not be considered a substitute for official documentation. Actual battery performance may vary due to various factors, including but not limited to, charging behavior, vehicle usage, operational conditions, and potential delays in data transmission.</li>
            <li>For questions or more information, please contact your Cummins representative.</li>
          </ul>
        </em>
      </div>
    </Paper>

    <Paper className='paper-btr-summary'>
    <div className='title-btr'><b>Summary</b> (For SMN - {SMN_EV_101B})</div>
        <Table className='list-table-btr'>
          <TableHead>
            <TableRow>
              <TableCell className='table-heading'>Battery Status</TableCell>
              <TableCell className='table-heading'>No. of Battery Packs</TableCell>
              <TableCell className='table-heading'>Life Remaining</TableCell>
              <TableCell className='table-heading'>Recommended Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody id='test-id'>
            {
              batteryPackSummaryList?.map((item, index) => (
              <TableRow key={index}>
                  <TableCell>
                    <FontAwesomeIcon className={'battery-icon-'+item.batteryPackStatus} title={'Battery Life Remaining - '+item.batteryLifeRemDescription}
                                    icon={item.batteryPackStatus === 'GREEN' ?
                                            (faBatteryFull) :
                                            item.batteryPackStatus === 'BLUE' ?
                                            (faBatteryThreeQuarters) :
                                            item.batteryPackStatus === 'YELLOW' ?
                                            (faBatteryHalf) :
                                            item.batteryPackStatus === 'ORANGE' ?
                                            (faBatteryQuarter) :
                                            (faBatteryEmpty)
                                         }
                    />
                  </TableCell>
                  <TableCell>
                    {item.batteryPackCount}
                  </TableCell>
                  <TableCell>
                    {item.batteryLifeRemDescription}
                  </TableCell>
                  <TableCell>
                    {item.batteryLifeRecomAction}
                  </TableCell>
              </TableRow>
              ))
            }
          </TableBody>
        </Table>
      </Paper>
      <Paper className='paper-btr-vehicle' >
      <div className='title-btr'><b>Vehicle Battery Pack Status</b> (For SMN - {SMN_EV_101B})  <FontAwesomeIcon className='info-icon' title='If you are not seeing Battery Pack Status of any vehicle, please contact AcceleraDigital.Support@cummins.com' icon={faInfoCircle}> </FontAwesomeIcon> </div>
      <Table className='list-table-btr'>
        <TableHead>
          <TableRow>
            <TableCell className='table-heading'>Bus</TableCell>
            <TableCell className='table-heading'>SSN</TableCell>
            <TableCell className='table-heading table-cell-pack'>Pack1</TableCell>
            <TableCell className='table-heading table-cell-pack'>Pack2</TableCell>
            <TableCell className='table-heading table-cell-pack'>Pack3</TableCell>
            <TableCell className='table-heading table-cell-pack'>Pack4</TableCell>
            <TableCell className='table-heading table-cell-pack'>Pack5</TableCell>
            <TableCell className='table-heading table-cell-pack'>Pack6</TableCell>
            <TableCell className='table-heading table-cell-pack'>Pack7</TableCell>
          </TableRow>
        </TableHead>
        <TableBody id='test-id'>
            {
              batteryLifeInfoList?.map((item, index) => (
                <TableRow key={index}>
                  <TableCell>
                    <img className='ev' src={IconElectricity} alt='Icon-Electricity'/>
                    <span> {item.busNo}</span>
                  </TableCell>
                  <TableCell>
                    {item.ssn}
                  </TableCell>
                      {
                        item.packInfoList?.map((infoItem, infoIndex) => {
                          //{console.log(' infoItem index: '+infoIndex+' infoItem packIndex: '+infoItem.packIndex)}
                          return (
                              (infoItem.packStatus == '-') ?
                              <TableCell key={infoIndex}>
                                -
                              </TableCell>
                              :
                              (infoItem.packStatus == 'No Data') ?
                              <TableCell key={infoIndex}>
                                {infoItem.packStatus} <FontAwesomeIcon className='info-icon-small' title='No data available for this SSN. Please contact your Cummins Representative.' icon={faInfoCircle}> </FontAwesomeIcon>
                              </TableCell>
                              :
                              (infoItem.packStatus == '') ?
                               <TableCell key={infoIndex}>
                                {infoItem.packStatus}
                              </TableCell>
                              :
                              <TableCell key={infoIndex}>
                                <FontAwesomeIcon className={'battery-icon-'+infoItem.packStatus}
                                                title={'Battery Life Remaining - '+infoItem.packLifeRemDescription}
                                                icon={infoItem.packStatus === 'GREEN' ?
                                                        (faBatteryFull) :
                                                        infoItem.packStatus === 'BLUE' ?
                                                        (faBatteryThreeQuarters) :
                                                        infoItem.packStatus === 'YELLOW' ?
                                                        (faBatteryHalf) :
                                                        infoItem.packStatus === 'ORANGE' ?
                                                        (faBatteryQuarter) :
                                                        (faBatteryEmpty)
                                                      }
                                />
                              </TableCell>
                          )
                        })
                      }

              </TableRow>
              ))

            }


        </TableBody>
      </Table>
    </Paper>
    </>
  ) : (
      <div className='page-loader'>
        <CircularProgress />
      </div>
    );

};
